import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import { ILegalEntitiesBusinessesResponse } from '../models/businesses.model';
import * as actions from '../actions';
import { IRouteTrackModel } from '../../../../../src/app/core/models/route-track.model';

export const selectedLegalEntityFeatureKey = 'selectedLegalEntity';

export interface SelectedLegalEntityState {
  selectedLegalEntity: ILegalEntitiesBusinessesResponse;
  isSideNavActive: boolean;
  isSideNavHidden: boolean;
  routeTracker: IRouteTrackModel[];
}

export const initialState: SelectedLegalEntityState = {
  selectedLegalEntity: undefined,
  isSideNavActive: false,
  isSideNavHidden: true,
  routeTracker: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadSelectedLegalEntity, (state, action) => ({
    ...state,
    selectedLegalEntity: action.selectedLE
  })),
  on(actions.loadIsSideNavActive, (state, action) => ({
    ...state,
    isSideNavActive: action.isSideNavActive
  })),
  on(actions.loadIsSideNavHidden, (state, action) => ({
    ...state,
    isSideNavHidden: action.isSideNavHidden
  })),
  on(actions.loadTrackRoutes, (state, action) => ({
    ...state,
    routeTracker: action.routes
  })),
  on(actions.clearTrackRoutes, (state, action) => ({
    ...state,
    routeTracker: undefined
  }))
);

export const getSelectedLegalEntity = (state: SelectedLegalEntityState) => state.selectedLegalEntity;

export const getIsSideNavEnabled = (state: SelectedLegalEntityState) => state.isSideNavActive;

export const getIsSideNavHidden = (state: SelectedLegalEntityState) => state.isSideNavHidden;

export const getTrackRoutes = (state: SelectedLegalEntityState) => state.routeTracker;
